import React, {useState} from 'react';
import './App.css';
import UploadForm from "./UploadForm";
import Result from "./Result";

function App() {
    const [prediction, setPrediction] = useState({"prediction" : "none"});
    const handlePrediction = (result: string) => {
        setPrediction({"prediction": result});
    };

    return (
        <div className="flex flex-col items-stretch">
            <div className="container grid grid-cols-1 w-4/5 gap-4 mx-auto justify-center">
                <div><h1 className="text-6xl font-extrabold text-center">Strato-like or tele-like</h1></div>
                <div><img src={"guitar.jpg"} alt="Two bots holding guitars" width={300} height={300} className="my-8 mx-auto"/></div>
                <div className={"text-center"}><p>Upload a picture of a guitar and our robots will tell you if this is a strato or a telecaster like guitar.</p></div>
                <div><UploadForm onPredictionComplete={handlePrediction}/></div>
                <div><Result prediction={prediction}/></div>
                <div className={"bg-orange-100 absolute bottom-0 left-0 w-full"}><p className={"text-center font-thin"}>Brought to you with ♥ by: <a href={"https://evilmeow.com/@rafadc"} className={"text-blue-600"}>rafadc</a></p></div>
            </div>
        </div>
    );
}

export default App;
